import {Heading, HStack, Icon, VStack} from 'platform/foundation';

import {isNilOrEmpty} from 'ramda-adjunct';

import {Payment} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {CorrectiveTaxDocumentCardV2} from './CorrectiveTaxDocumentCardV2';

interface CorrectiveTaxDocumentsListV2Props extends RequiredTestIdProps {
  correctivePayments: Payment[] | Nullish;
  checkoutId: string;
  customerId: string;
  serviceCaseId?: string;
  serviceOrderId?: string;
  isEditingDisabled?: boolean;
  isCompletingDisabled?: boolean;
}

export function CorrectiveTaxDocumentsListV2(props: CorrectiveTaxDocumentsListV2Props) {
  if (isNilOrEmpty(props.correctivePayments)) {
    return null;
  }

  return (
    <VStack spacing={4}>
      <HStack spacing={2}>
        <Icon value="editor/insert_drive_file" />
        <Heading size={4}>{i18n.t('entity.accounting.labels.correctiveTaxDocuments')}</Heading>
      </HStack>
      {props.correctivePayments?.map((payment, index) => (
        <CorrectiveTaxDocumentCardV2
          key={payment.checkoutPaymentId}
          paymentId={payment.checkoutPaymentId}
          checkoutId={props.checkoutId}
          customerId={props.customerId}
          serviceCaseId={props.serviceCaseId}
          serviceOrderId={props.serviceOrderId}
          isEditingDisabled={props.isEditingDisabled}
          isCompletingDisabled={props.isCompletingDisabled}
          data-testid={suffixTestId(`document-${index}`, props)}
        />
      ))}
    </VStack>
  );
}
